<template>
    <span v-show="show">
        <slot></slot>
    </span>
</template>
<script>
import {checkPermissions} from '@/utils'
export default {
    name:"custom-permissions",
    props:{
        permission:{
            type:String,
        }
    },
    data(){
        return {
            show:false,
        }
    },
    created(){
        const showStatus = checkPermissions(this.permission)
        console.log(showStatus)
        this.show = showStatus
    }
}
</script>



// WEBPACK FOOTER //
// src/components/custom-permissions/index.vue